import type { Client } from './client';

export interface MessageToEval {
  role: 'user' | 'assistant' | 'tool';
  text: string | null;
  fileUrl?: string | null;
  fileName?: string | null;
  mediaId?: string | null;
  toolCalls?:
    | {
        id: string;
        type: 'function';
        function: {
          name: string;
          arguments: string;
        };
      }[]
    | null;
  toolCallId?: string | null;
  expected?: {
    responseDistance?: number;
    responseDescription: string;
  };
  key?: string;
}

export interface ConversationEval {
  id: number;
  createdAt: string;
  updatedAt: string;
  businessUnitIds: number[];
  mockClient: Partial<Client>;
  messages: MessageToEval[];
}

type ChatCompletionResponse = {
  completionMessageContent: string | null;
  toolCalls?: unknown[] | null;
  /* completionUsage?: OpenAI.Completions.CompletionUsage | null;
  model: AIModel; */
};

type EvalData = {
  businessUnitId: number;
  mockClient: Client;
  messages: unknown[];
  expected: {
    responseDistance?: number;
    expectedCompletionMessageContent?: string;
    expectedToolCalls?: {
      name: string;
      arguments: string;
    }[];
    responseDescription: string;
  };
};

/** One graded case, streamed under a `success_N` / `partial_N` / `failure_N` key. */
export type RunConversationEvalCase = {
  evalData: EvalData;
  response: ChatCompletionResponse;
  alignmentScore?: number;
  completionTime: number;
  score: number;
};

export type RunConversationEvalResponse = {
  successCount: number;
  total: number;
  approved: boolean;
  totalCosts: number;
  successRate: number;
  failures: {
    evalData: EvalData;
    response: ChatCompletionResponse;
    alignmentScore: number | undefined;
  }[];
  successes: {
    evalData: EvalData;
    response: ChatCompletionResponse;
  }[];
  /** Per-case results arrive under dynamic keys, one per graded case. */
  [caseKey: string]: unknown;
};

export function isRunConversationEvalError(
  error: unknown
): error is { data: RunConversationEvalResponse; status: number } {
  return (
    typeof error === 'object' &&
    error !== null &&
    'data' in error &&
    'status' in error &&
    'failures' in (error.data as RunConversationEvalResponse)
  );
}

export interface BlindComparisonResponse {
  successCount: number;
  total: number;
  approved: boolean;
  costsPerModel: Record<string, number>;
  costsEvaluation: number;
  totalCosts: number;
  successRate: number;
  models: string[];
  evaluationModel: string;
  threshold: number;
  [key: string]: unknown;
}
